import React,{useEffect, useState, useRef} from 'react';
import { FormattedMessage, } from '../../util/reactIntl';
import classNames from 'classnames';
import { PrimaryButton, SecondaryButton } from '../../components';
import { Modal, Logo } from '../../components';
import { useHistory } from 'react-router';

import css from './TransactionPanel.css';

// Functional component as a helper to build ActionButtons for
// provider when state is preauthorized
const SaleActionButtonsMaybe = props => {
  const {
    className,
    rootClassName,
    showButtons,
    showAcceptButton,
    acceptInProgress,
    declineInProgress,
    acceptSaleError,
    declineSaleError,
    onAcceptSale,
    onDeclineSale,
    onRequestPayment,
    onConfirmBooking,
    transaction,
    showConfirmationButton,

  } = props;


  const buttonsDisabled = acceptInProgress || declineInProgress;
  const goToCheckout = () => {
    onRequestPayment(transaction);
  };

  const confirmBooking= () =>{

    onConfirmBooking(transaction.booking);



 
  }

  const acceptErrorMessage = acceptSaleError ? (
    <p className={css.actionError}>
      <FormattedMessage id="TransactionPanel.acceptSaleFailed" />
    </p>
  ) : null;
  const declineErrorMessage = declineSaleError ? (
    <p className={css.actionError}>
      <FormattedMessage id="TransactionPanel.declineSaleFailed" />
    </p>
  ) : null;

  const classes = classNames(rootClassName || css.actionButtons, className);
  return(<div>

  {showButtons ? (
    <div className={classes}>
      <div className={css.actionErrors}>
        {acceptErrorMessage}
        {declineErrorMessage}
      </div>
      <div className={css.actionButtonWrapper}>
        <SecondaryButton
          inProgress={declineInProgress}
          disabled={buttonsDisabled}
          onClick={onDeclineSale}
          >
          <FormattedMessage id="TransactionPanel.declineButton" />
        </SecondaryButton>
        <PrimaryButton
          inProgress={acceptInProgress}
          disabled={buttonsDisabled}
          onClick={onAcceptSale}
          >
          <FormattedMessage id="TransactionPanel.acceptButton" />
        </PrimaryButton>
      </div>
    </div>
  ) : showAcceptButton ? (
    <div className={classes}>
      <div className={css.actionErrors}></div>
      <div className={css.actionButtonWrapper}>
        <PrimaryButton onClick={goToCheckout}>
          <FormattedMessage id="TransactionPanel.payButton" />
        </PrimaryButton>
      </div>
    </div>
  ) : showConfirmationButton ? (
    <div className={classes}>
      <div className={css.actionErrors}></div>
      <div className={css.actionButtonWrapper}>
        <PrimaryButton onClick={confirmBooking}><FormattedMessage id="TransactionPanel.submitBooking" /></PrimaryButton>
      </div>

     

    </div>
  ) : null
}
        </div> 
)};

export default SaleActionButtonsMaybe;
